export enum DateTimeLayout {
  Rows = 'rows',
  Cards = 'cards',
  Stacked = 'stacked',
  Compact = 'compact',
}
